import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Loader from "../loader";
import Spinner from "../Spinner";
import { useDispatch } from "react-redux";
import {
  AddRadar,
  ChangeStatus,
  DeleteCity,
  EditRadar,
  GetRadarList,
  SearchCity,
} from "../../../actions/auth";
import moment from "moment";
import ReactModal from "react-modal";
import "../../../assests/css/Styless.css";
import Pagination from "react-js-pagination";
import swal from "sweetalert";

const RadarList = () => {
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
  const [city, setCity] = useState("");
  const [cityErr, setCityErr] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedRadarId, setSelectedRadarId] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [activePage, setActivePage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [listReducer, setListReducer] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [NoData, setNoData] = useState(false);

  const [searchData, setSearchData] = useState("");

  const total = list?.totalOptions;

  useEffect(() => {
    if (searchData) {
      setLoadingData(true);
      dispatch(SearchCity(activePage, searchData)).then((response) => {
        if (response?.data.length > 0) {
          if (response?.success == true) {
            setNoData(false);
            setListReducer(response);
            setList(response?.data);
          }
        } else {
          setNoData(true);
          setList(response?.data);
          // setList([]);
        }
      });
    } else {
      setLoading(true);
      dispatch(GetRadarList(activePage)).then((response) => {
        if (response.success) {
          setListReducer(response);
          setList(response?.data);
        }
        setLoading(false);
      });
    }
  }, [activePage]);

  // useEffect(() => {
  //   dispatch(GetRadarList(activePage));
  // }, [list]);

  const openModal = (isEdit = false, radar = null) => {
    setIsEditMode(isEdit);
    if (isEdit && radar) {
      setCity(radar.city);
      setSelectedRadarId(radar?._id);
    } else {
      setCity("");
      setSelectedRadarId(null);
    }
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setCity("");
    setCityErr("");
    setSelectedRadarId(null);
    document.body.style.overflow = "auto";
  };

  // const handleCityChange = (e) => {
  //   const trimmedValue = e.target.value.trimStart();
  //   setCity(trimmedValue);
  //   setCityErr(trimmedValue ? "" : "Please enter a city.");
  // };

  const handleCityChange = (e) => {
    const trimmedValue = e.target.value.trimStart();

    // Regular expression to allow only alphanumeric characters, dot, and dash
    const validCityPattern = /^[a-zA-Z0-9 ,.-]*$/;

    if (validCityPattern.test(trimmedValue)) {
      setCity(trimmedValue);
      setCityErr(trimmedValue ? "" : "Please enter a city.");
    }
    // else {
    //   setCityErr("Please enter a valid city.");
    // }
  };

  const handleSubmit = () => {
    if (city === "") {
      setCityErr("Please enter a city.");
      return;
    }

    const radarData = { city };

    if (isEditMode && selectedRadarId) {
      dispatch(EditRadar(radarData, selectedRadarId)).then(() => {
        // Update the list after edit
        setLoadingData(true);
        dispatch(GetRadarList()).then((response) => {
          if (response.success) {
            setList(response?.data);
            swal("", "City updated successfully.", "success");
          }
          setLoadingData(false);
        });
      });
    } else {
      dispatch(AddRadar(radarData)).then(() => {
        setLoadingData(true);
        dispatch(GetRadarList(activePage)).then((response) => {
          if (response.success) {
            setList(response?.data);
            swal("", "City added successfully.", "success");
          }
          setLoadingData(false);
        });
      });
    }
    closeModal();
  };
  const handleKeyPress = (e) => {
    if (e.key == "Enter") {
      e.preventDefault();
      closeModal();

      handleSubmit();
    }
  };
  const calculateRange = () => {
    const currentPage = activePage;
    const itemsPerPage = 10;

    const startIndex = (currentPage - 1) * itemsPerPage + 1;

    let endIndex = currentPage * itemsPerPage;
    if (endIndex > total) {
      endIndex = total;
    }

    return `Showing ${startIndex} to ${endIndex} of ${total} entries`;
  };

  const handlePageChange = (pagenumber) => {
    if (pagenumber) {
      setLoadingData(true);
      dispatch(GetRadarList(pagenumber)).then(() => {
        setLoadingData(false); // Stop loading
      });
      setActivePage(pagenumber);
    }
  };

  function toggleSwitch(e, event) {
    console.log(event.target.checked, "event.target.checked");
    const newStatusText = event.target.checked == true ? "1" : "0";
    const newStatusText2 = event.target.checked == true ? "active" : "inactive";

    document.body.classList.add("swal-open-modal");

    swal({
      text: `Are you sure you want to ${newStatusText2} this status?`,
      icon: "warning",
      buttons: true,
      className: "swal-custom-modal",
    }).then((willConfirm) => {
      document.body.classList.remove("swal-open-modal");
      
      if (willConfirm) {
        setLoadingData(true);
        console.log(event.target.checked, "event.target.checked");
        dispatch(ChangeStatus({ status: newStatusText }, e?._id)).then(
          (response) => {
            if (response.success) {
              dispatch(GetRadarList(activePage)).then((response) => {
                if (response.success) {
                  setListReducer(response);
                  setList(response?.data);
                }
                setLoadingData(false);
              });
            }
          }
        );
        //   .then(
        //   (response) => {
        //     if (response.success) {
        //       dispatch(GetRadarList(activePage)).then((response) => {
        //         if (response.success) {
        //           setListReducer(response);
        //            setList(response?.data);;
        //         }
        //         setLoading(false);
        //       });
        //     }
        //   }
        // );

        // if (event.target.checked == "1") {
        //   swal("Your status is Inactive!", { icon: "success" });
        // } else {
        //   swal("Your status is active!", { icon: "success" });
        // }
        //   .then(() => {

        //   dispatch(GetRadarList()).then((response) => {
        //     if (response.success) {
        //        setList(response?.data);;
        //     }
        //   });
        // });
      }
    });
  }

  const searchList = (e) => {
    const data = e.target.value.trimStart();
    console.log(data, "mmmmmmm");
    setSearchData(data);
    setActivePage(1);
    if (data) {
      setLoadingData(true);
      dispatch(SearchCity(activePage, data)).then((response) => {
        if (response?.data.length > 0) {
          if (response?.success == true) {
            setNoData(false);
            setListReducer(response);
            setList(response?.data);
          }
        } else {
          setNoData(true);
          setList(response?.data);
          // setList([]);
        }
        setLoadingData(false);
      });
    } else {
      setNoData(false);
      setLoadingData(true);
      dispatch(GetRadarList(activePage)).then((response) => {
        if (response?.success) {
          setListReducer(response);
          setList(response?.data);
          setLoadingData(false);
        }
        setLoadingData(false);
      });
    }
    setLoadingData(false);
  };

  const handleSearch = () => {
    if (searchData) {
      setLoadingData(true);
      dispatch(SearchCity(activePage, searchData)).then((response) => {
        if (response?.data.length > 0) {
          if (response?.success == true) {
            setNoData(false);
            setListReducer(response);
            setList(response?.data);
          }
        } else {
          setNoData(true);
          setList(response?.data);
          // setList([]);
        }
      });
    } else {
      setNoData(false);
      setLoadingData(true);
      dispatch(GetRadarList(activePage)).then((response) => {
        if (response?.success) {
          setListReducer(response);
          setList(response?.data);
        }
        setLoadingData(false);
      });
    }
    setLoadingData(false);
  };

  console.log(list, "list.........");

  const HandleDelete = (e) => {
    document.body.classList.add("swal-open-modal");

    swal({
      text: `Are you sure you want to delete this city?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willConfirm) => {
      document.body.classList.remove("swal-open-modal");

      if (willConfirm) {
        if (e) {
          setLoadingData(true);
          dispatch(DeleteCity(e)).then((response) => {
            swal("", "City deleted successfully", "success");
            if (response.success) {
              dispatch(GetRadarList(activePage)).then((response) => {
                if (response.success) {
                  setListReducer(response);
                  setList(response?.data);
                }
                setLoadingData(false);
              });
            }
          });
        }
      }
    });
  };

  const [sortOrder, setSortOrder] = useState("asc"); // 'asc' or 'desc'

  const sortCities = (order) => {
    const sortedCities = [...list.records].sort((a, b) => {
      if (a.city < b.city) return order === "asc" ? -1 : 1;
      if (a.city > b.city) return order === "asc" ? 1 : -1;
      if (a.createdAt < b.createdAt) return order === "asc" ? -1 : 1;
      if (a.createdAt > b.createdAt) return order === "asc" ? 1 : -1;
      return 0;
    });
    setList({ ...list, records: sortedCities }); // Update the list state with sorted data
  };

  const handleSortChange = () => {
    const newOrder = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(newOrder);
    sortCities(newOrder);
  };

  const handleClearSearch = () => {
    if (searchData) {
      setSearchData("");
      setLoading(true);

      dispatch(GetRadarList(activePage)).then((response) => {
        setListReducer(response);
        if (response.success) {
          setList(response?.data);
        }
        setLoading(false);
      });
    }
  };

  // const [sortOrder2, setSortOrder2] = useState("asc"); // 'asc' or 'desc'

  // const sortCities2 = (order) => {
  //   const sortedCities = [...list.records].sort((a, b) => {
  //     if (a.createdAt < b.createdAt) return order === "asc" ? -1 : 1;
  //     if (a.createdAt > b.createdAt) return order === "asc" ? 1 : -1;
  //     return 0;
  //   });
  //   setList({ ...list, records: sortedCities }); // Update the list state with sorted data
  // };

  // const handleSortChange2 = () => {
  //   const newOrder = sortOrder2 === "asc" ? "desc" : "asc";
  //   setSortOrder2(newOrder);
  //   sortCities2(newOrder);
  // };
  // // // sorting code
  // const [order, setOrder] = useState("ASC");

  // const Sortt = (col) => {

  //   const { records } = list; // Extract the records array from the list object

  //   if (!Array.isArray(records)) {
  //     console.error("Error: records is not an array", records);
  //     return;
  //   }

  //   let sortedRecords;
  //   if (order === "ASC") {
  //     sortedRecords = [...records].sort((a, b) =>
  //       (a[col]?.toLowerCase() || "") > (b[col]?.toLowerCase() || "") ? 1 : -1
  //     );
  //     setOrder("DSC");
  //   } else if (order === "DSC") {
  //     sortedRecords = [...records].sort((a, b) =>
  //       (a[col]?.toLowerCase() || "") < (b[col]?.toLowerCase() || "") ? 1 : -1
  //     );
  //     setOrder("ASC");
  //   }

  //   // Update the list with the sorted records
  //   setList({
  //     ...list,
  //     records: sortedRecords,
  //   });
  // };

  return (
    <>
      <ReactModal
        isOpen={modalIsOpen}
        style={{
          overlay: {
            background: "rgba(0, 0, 0, .50)",
            zIndex: "999",
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            minWidth: "570px",
            border: "none",
            padding: "0px",
            animation: "pop-up 0.5s forwards",
            overflow: "hidden",
          },
        }}
      >
        <div className="modal-header pb-3">
          <h6 className="modal-title">
            {isEditMode ? "Edit Radar" : "Add Radar"}
          </h6>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeModal}
          ></button>
        </div>
        <div className="modal-content border-0">
          <div className="modal-body">
            <form>
              <div className="mb-3">
                <label className="text-black fw-bold mb-2">
                  {isEditMode ? "Edit City" : "Add City"}
                  <span className="redErrMsg"> *</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter City"
                  className="form-control"
                  value={city}
                  maxLength={50}
                  minLength={2}
                  onChange={handleCityChange}
                  onKeyDown={handleKeyPress}
                />
                {cityErr && <p className="text-danger">{cityErr}</p>}
              </div>
            </form>
          </div>
        </div>
        <div className="modal-footer pt-3">
          <button type="button" className="btn btn-light" onClick={closeModal}>
            Close
          </button>
          <button
            type="button"
            className="btn btn-primary ms-2"
            onClick={handleSubmit}
          >
            {isEditMode ? "Edit" : "Submit"}
          </button>
        </div>
      </ReactModal>

      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Radar Locations
                  </h6>
                </div>
                <div className="card-body">
                  <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                    <div className="row mb-2 ">
                      <div className="col-md-4">
                        <div>
                          <input
                            type="text"
                            className="form-control search-input-new"
                            placeholder="Search here"
                            value={searchData}
                            onChange={searchList}
                            // onKeyDown={handleSearch}
                          />
                        </div>
                        {searchData.length >= 1 && (
                          <div
                            onClick={handleClearSearch}
                            className="cross-serach-new"
                          >
                            <i className="fa fa-times cursor-pointerr"></i>
                          </div>
                        )}
                      </div>
                      <div className="col-md-2">
                        <button
                          className="btn btn-primary form-control"
                          onClick={handleSearch}
                          // onKeyDown={handleSearch}
                        >
                          Search
                        </button>
                      </div>
                      <div className="col-md-2">
                        <button
                          className="btn btn-primary form-control"
                          onClick={() => openModal(false)}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {loading ? (
                  <div className="loader-container">
                    <div className="loaderss"></div>
                  </div>
                ) : (
                  <div style={{ paddingLeft: 30, paddingRight: 30 }}>
                    <table className="table radar-table">
                      <thead>
                        <tr>
                          <th scope="col">No</th>
                          <th scope="col">
                            City
                            <i
                              onClick={handleSortChange}
                              className="fa fa-sort cursor-pointerr"
                              height="15px"
                              width="15px"
                              style={{ marginLeft: 5 }}
                            ></i>{" "}
                          </th>
                          <th scope="col">
                            Created at
                            <i
                              onClick={handleSortChange}
                              className="fa fa-sort cursor-pointerr"
                              height="15px"
                              width="15px"
                              style={{ marginLeft: 5 }}
                            ></i>
                          </th>
                          <th scope="col">Status</th>
                          <th scope="col">Edit</th>
                          <th scope="col">Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {console.log("LISTTTTTTT", list)}
                        {loadingData ? (
                          <div className="overlay">
                            <div className="loader bg-transparent">
                              <Spinner />
                            </div>
                          </div>
                        ) : (
                          <>
                            {list && list?.records?.length > 0 ? (
                              list?.records?.map((e, index) => (
                                <>
                                  <tr key={e._id}>
                                    <th scope="row">
                                      {(activePage - 1) * itemsPerPage +
                                        (index + 1)}
                                    </th>
                                    <td>{e?.city ? e?.city : "-"}</td>
                                    <td>
                                      {moment(e.createdAt).format("MM/DD/YYYY")}
                                    </td>
                                    <td>
                                      <div className="form-check form-switch">
                                        <input
                                          className="form-check-input cursor-pointerr"
                                          type="checkbox"
                                          key={e?._id}
                                          role="switch"
                                          id="flexSwitchCheckDefault"
                                          checked={
                                            e?.status == "inactive"
                                              ? false
                                              : true
                                          }
                                          defaultChecked={
                                            e?.status == "inactive"
                                              ? false
                                              : true
                                          }
                                          onClick={(event) =>
                                            toggleSwitch(e, event)
                                          }
                                        />
                                      </div>
                                    </td>
                                    <td
                                      onClick={() => openModal(true, e)}
                                      className="cursor-pointerr"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </td>
                                    <td
                                      onClick={() => HandleDelete(e._id)}
                                      className="cursor-pointerr"
                                    >
                                      <i className="fas fa-trash"></i>
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={6}>
                                  <h5
                                    style={{ textAlign: "center" }}
                                    className="mt-3"
                                  >
                                    No results found
                                  </h5>
                                </td>
                              </tr>
                            )}
                          </>
                        )}
                      </tbody>
                    </table>

                    {list && list?.records?.length > 0 ? (
                      <div className="d-flex justify-content-between mt-3 align-items-center">
                        <ul className="mt-3 ps-0">
                          <p>
                            {/* {list && list?.data?.totalOptions > 0 */}
                            {calculateRange()}
                            {/* : ""} */}
                          </p>
                        </ul>
                        <Pagination
                          activePage={activePage}
                          itemsCountPerPage={itemsPerPage}
                          totalItemsCount={total}
                          pageRangeDisplayed={10}
                          // onChange={handlePageChange}
                          onChange={
                            total > itemsPerPage ? handlePageChange : null
                          }
                          itemClass="page-item"
                          linkClass={
                            total && total > 0
                              ? "page-link"
                              : "page-link disabled"
                          }
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RadarList;
